'use strict'

module.exports = () => ({
  isValidContext: () => false
})



// WEBPACK FOOTER //
// ./adapters/nullAdapter.js